'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../../_tslib-15827112.js');
var BaseController = require('../BaseController.js');

var TicketsController = /** @class */ (function (_super) {
    _tslib.__extends(TicketsController, _super);
    function TicketsController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.basePath = "/Ticket";
        return _this;
    }
    TicketsController.prototype.Get = function (id) {
        var endpoint = this.basePath + "/" + id;
        return this.MakeRequest({
            url: endpoint,
        });
    };
    TicketsController.prototype.GetHistory = function (days) {
        var endpoint = this.basePath + "/History/" + this.config.countryCode + (days ? "/" + days : "");
        return this.MakeRequest({
            url: endpoint,
        });
    };
    TicketsController.prototype.GetImage = function (imageName, size) {
        if (size === void 0) { size = ""; }
        var endpoint = size != ""
            ? this.basePath + "/Image/" + this.config.countryCode + "/" + size + "/" + imageName
            : this.basePath + "/Image/" + this.config.countryCode + "/" + imageName;
        return this.MakeRequest({
            url: endpoint,
        });
    };
    TicketsController.prototype.Post = function (images, promoCoupons, origin, referrerHash, lat, lng) {
        var endpoint = this.basePath;
        var payload = new FormData();
        payload.append("Country", this.config.countryCode);
        payload.append("UserId", this.getUserId());
        payload.append("Origin", origin);
        if (referrerHash) {
            payload.append("ReferrerHash", referrerHash);
        }
        promoCoupons.forEach(function (coupon) {
            payload.append("PromoCoupons", JSON.stringify(coupon));
        });
        images.forEach(function (image) {
            payload.append("Files", image);
        });
        return this.MakeRequest({
            method: "POST",
            url: endpoint,
            data: payload,
            params: {
                lat: lat,
                lng: lng
            }
        });
    };
    return TicketsController;
}(BaseController.default));

exports.default = TicketsController;
//# sourceMappingURL=TicketsController.js.map
